/* eslint-disable @typescript-eslint/no-explicit-any */
import { newRelicNoticeError } from '@lib/tracking/newrelic'
import { useWebPageByHostPathQuery } from '@ts/operations'
import dynamic from 'next/dynamic'
import { ErrorProps } from 'next/error'
import { useRouter } from 'next/router'
import React, { ComponentType } from 'react'

import ContentElement from './ContentElement'

const BasePageLayout = dynamic(() => import('../layouts/BasePageLayout'))
const MetaTags = dynamic(() => import('../metaTags/MetaTags'))

const errorImport: () => any = () => import('next/error')

const ErrorComponent: ComponentType<ErrorProps> = dynamic(errorImport)

export const getWebPageByHostPathVariables = (path: string) => ({
  host: process.env.WEB_HOST as string,
  path: path.split('?')[0],
})

const WebPageProvider = () => {
  const { asPath } = useRouter()

  const { data } = useWebPageByHostPathQuery({
    variables: getWebPageByHostPathVariables(asPath),
  })

  if (!data) return null

  const { webPageByHostPath } = data
  if (!webPageByHostPath) {
    newRelicNoticeError(`Not Found: ${asPath}`)
    return <ErrorComponent statusCode={404} title="Web Page Not found" />
  }

  const { title, seoTags } = webPageByHostPath

  return (
    <BasePageLayout title={title}>
      <MetaTags seoTags={seoTags ?? undefined} title={title} />
      {webPageByHostPath?.content.map(item =>
        'id' in item ? <ContentElement key={item.id} item={item} /> : null
      )}
    </BasePageLayout>
  )
}

export default WebPageProvider
